import { render, staticRenderFns } from "./LockLoad.vue?vue&type=template&id=bed819ac&scoped=true"
import script from "./LockLoad.vue?vue&type=script&lang=js"
export * from "./LockLoad.vue?vue&type=script&lang=js"
import style0 from "./LockLoad.vue?vue&type=style&index=0&id=bed819ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed819ac",
  null
  
)

export default component.exports